import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import DBACheckLanding from "@/pages/DBACheckLanding";
import Questionnaire from "@/pages/Questionnaire";
import Results from "@/pages/Results";
import PremiumReport from "@/pages/PremiumReport";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ReportAccess from "@/pages/ReportAccess";
import Admin from "@/pages/Admin";
import PartnerSignup from "@/pages/PartnerSignup";
import PartnerLogin from "@/pages/PartnerLogin";
import PartnerDashboard from "@/pages/PartnerDashboard";
import PartnerForgotPassword from "@/pages/PartnerForgotPassword";
import PartnerResetPassword from "@/pages/PartnerResetPassword";

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dba-check" element={<DBACheckLanding />} />
          <Route path="/dba-check/vragenlijst" element={<Questionnaire />} />
          <Route path="/dba-check/resultaat/:submissionId" element={<Results />} />
          <Route path="/dba-check/rapport/:submissionId" element={<PremiumReport />} />
          <Route path="/report/access/:token" element={<ReportAccess />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<Admin />} />
          {/* Partner/Affiliate Routes */}
          <Route path="/partner" element={<PartnerSignup />} />
          <Route path="/partner-login" element={<PartnerLogin />} />
          <Route path="/partner-dashboard" element={<PartnerDashboard />} />
          <Route path="/partner-forgot-password" element={<PartnerForgotPassword />} />
          <Route path="/partner-reset-password" element={<PartnerResetPassword />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
